import React from 'react';
import request, { METHODS } from '@/api'
import { useEffect, useState } from 'react'
import {
  SEditor,
  SDrawerOrModal,
} from 'shj-components'
import {Form, Input, Select, message, DatePicker, InputNumber} from 'antd';
import dayjs from 'dayjs';
import {
  confirmArrive,
  arrivalTypeEnum,
  functionNeedEnum,
  getHouseTypeEnum,
  getHouseDecorateStyleEnum,
  getBudGetEnums
} from '@/services/customerServices';
import styles from './index.module.less'
import {trimStr} from "@/utils/data.ts";
import {clueConfirmToShop} from "@/services/callCenter";

const TextArea = Input.TextArea;

export default function ConfirmModal ({
  editId = '',
  open = false,
  buttonKey = '',
  basicInfo = {},
  onClose = () => {},
  reload = () => {},
})  {
  const [ form ] = Form.useForm();
  const [dictionaryData, setDictionaryData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log(basicInfo, 'basicInfo')
    form.setFieldsValue({
      doorNo: (basicInfo as any)?.houseInfo?.doorNo,
      handoverDate: (basicInfo as any)?.houseInfo?.handoverDate ? dayjs(basicInfo?.houseInfo?.handoverDate) : '',
      layout: (basicInfo as any)?.houseInfo?.layout,
      innerArea: (basicInfo as any)?.houseInfo?.innerArea,
      designStyleCode: (basicInfo as any)?.dtlInfo?.designStyleCode,
      houseDemand: (basicInfo as any)?.dtlInfo?.houseDemand,
      budget: (basicInfo as any)?.dtlInfo?.budget,
    })
    fetchDictionaryData();
  }, [basicInfo]);

  const fetchDictionaryData = async () => {
    try {
      setLoading(true)
      const resList: any = await Promise.allSettled([
        arrivalTypeEnum(),
        functionNeedEnum(),
        getHouseTypeEnum(),
        getHouseDecorateStyleEnum(),
        getBudGetEnums()
      ]);
      const map = {
        arrivalType: resList?.[0]?.value instanceof Array ? resList?.[0]?.value?.filter(item => item?.key !== 'pending') : [],
        houseDemand: resList?.[1]?.value instanceof Array ? resList?.[1]?.value : [],
        layout: resList?.[2]?.value instanceof Array ? resList?.[2]?.value : [],
        designStyleCode: resList?.[3]?.value instanceof Array ? resList?.[3]?.value : [],
        budget: resList?.[4]?.value instanceof Array ? resList?.[4]?.value : [],
      }
      setDictionaryData(map);
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const onSubmit = () => {
    form.validateFields().then((values: any) => {
      setLoading(true);
      const values_ = {
        ...values,
        arrivedDate: values.arrivedDate ? dayjs(values.arrivedDate).format('YYYY-MM-DD HH:mm:ss') : '',
        handoverDate: values.handoverDate ? dayjs(values.handoverDate).format('YYYY-MM-DD') : '',
        clueId: editId, buttonKey,
      }
      clueConfirmToShop(values_)
          .then(res => {
            message.success(res.message || '确认到店成功');
            onClose();
            reload();
          }).finally(() => setLoading(false))
    })
  }

  return (
    <div className={styles.confirmModal}>
      <SDrawerOrModal
        mode="drawer"
        open={open}
        onCancel={() => onClose()}
        onOk={onSubmit}
        loading={loading}
        width={500}
        title="确认到店"
      >
        <Form
          form={form}
          name="basicInfo"
          layout="vertical"
        >
         {/* <Form.Item
            name="arrivalType"
            label="是否到店"
            rules={[
              {
                required: true,
                message: '请选择是否到店',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择是否到店'} onChange={handleChangeArrival} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['arrivalType']} />
          </Form.Item>*/}
          <Form.Item
            name="arrivedDate"
            label="到店时间"
            rules={[
              {
                required: true,
                message: '请选择到店时间',
              },
            ]}
          >
            <DatePicker
                format="YYYY-MM-DD HH:00"
                showTime={{format: 'YYYY-MM-DD HH:00'}}
                style={{ width: '100%' }}
                disabledDate={current => {
                  return current && !dayjs(current).isSame(dayjs(), 'day')
                }}
            />
          </Form.Item>
         {/*注释 <Form.Item
            name="handoverDate"
            label="交房日期"
            rules={[
              {
                required: true,
                message: '请选择交房日期',
              },
            ]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>*/}
          <Form.Item
            name="doorNo"
            label="门牌号"
            rules={[
              {
                required: true,
                message: '请填写门牌号',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Input placeholder={'请填写门牌号'} maxLength={20} onChange={(e) => form.setFieldValue('doorNo', trimStr(e.target.value))} />
          </Form.Item>
          <Form.Item
            name="layout"
            label="户型"
            rules={[
              {
                required: true,
                message: '请选择户型',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择户型'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['layout']} />
          </Form.Item>
          <Form.Item
            name="innerArea"
            label="套内面积"
            rules={[
              {
                required: true,
                message: '请填写套内面积',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <InputNumber style={{width: '100%'}} placeholder={'请输入套内面积'} precision={2} min={0} max={999999999}/>
          </Form.Item>
          <Form.Item
            name="houseDemand"
            label="功能需求"
            rules={[
              {
                required: true,
                message: '请选择功能需求',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择功能需求'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['houseDemand']} />
          </Form.Item>
          <Form.Item
            name="designStyleCode"
            label="装修风格"
            rules={[
              {
                required: true,
                message: '请选择装修风格',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择装修风格'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['designStyleCode']} />
          </Form.Item>
          <Form.Item
            name="budget"
            label="预算"
            rules={[
              {
                required: true,
                message: '请选择预算',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择预算'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['budget']} />
          </Form.Item>
        </Form>
      </SDrawerOrModal>
    </div>
  )
}
